import { forwardRef } from 'react';
import {
  Tooltip as NextUITooltip,
  type TooltipProps as NextUITooltipProps,
} from '@heroui/tooltip';

export interface TooltipProps extends NextUITooltipProps {}

const container = {
  hover: {
    opacity: 1
  },
  normal: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const ActionBarTooltip = forwardRef((props: TooltipProps, ref: any) => {
  if (!props.content) return props.children;

  return (
    <NextUITooltip
      ref={ref}
      {...props}
      showArrow
      initial="normal"
      whileHover="hover"
      animate="hover"
      variants={container}
      delay={0}
      closeDelay={0}
      classNames={{
        base: ['before:bg-gray-30 dark:before:bg-gray-30 max-w-64'],
        content: ['py-2 px-3 rounded-md text-xs', 'bg-gray-30 dark:bg-gray-30 text-white'],
      }}
    />
  );
});

export default ActionBarTooltip;
